module.exports = __webpack_public_path__ + "img/p-two-step-01.35dd1ae3.png";